import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { LedComponent } from './led/led.component';
import { BtnComponent } from './btn/btn.component';
import { FatTextComponent } from './fat-text/fat-text.component';
import { MelderComponent } from './melder/melder.component';

@NgModule({
  declarations: [
    AppComponent,
    LedComponent,
    BtnComponent,
    FatTextComponent,
    MelderComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
